module.exports = __webpack_public_path__ + "img/shop2_1_m.9bc93dc9.png";